import React from 'react';

/**
 * Componente modular para encabezados de tabla con soporte de ordenamiento interactivo
 * (ascendente / descendente, numérico y alfabético).
 */
export const ThOrdenable = ({
  columna,
  titulo,
  tipo = 'alpha',
  columnaOrden,
  direccionOrden,
  onOrdenar,
  className = '',
  style = {},
  colors = {}
}) => {
  const esActivo = columnaOrden === columna;
  const esNum = tipo === 'num';

  // Determinación del icono dinámico de FontAwesome 6
  let iconoClase = '';
  if (esNum) {
    if (esActivo) {
      iconoClase = direccionOrden === 'asc' ? 'fa-arrow-down-1-9' : 'fa-arrow-down-9-1';
    } else {
      iconoClase = 'fa-arrow-down-1-9';
    }
  } else {
    if (esActivo) {
      iconoClase = direccionOrden === 'asc' ? 'fa-arrow-down-a-z' : 'fa-arrow-down-z-a';
    } else {
      iconoClase = 'fa-arrow-down-a-z';
    }
  }

  const tooltip = esActivo
    ? (direccionOrden === 'asc'
        ? `${titulo}: Orden ascendente (${esNum ? '1 a 9' : 'A a Z'}). Clic para ordenar de mayor a menor`
        : `${titulo}: Orden descendente (${esNum ? '9 a 1' : 'Z a A'}). Clic para ordenar de menor a mayor`)
    : `Clic para ordenar por ${titulo}`;

  const colorActivo = colors?.colorFont || '#0d6efd';
  const colorInactivo = colors?.colorFont || '#6c757d';

  return (
    <th
      scope="col"
      className={`user-select-none ${className}`}
      onClick={() => onOrdenar(columna)}
      title={tooltip}
      style={{
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'background-color 0.15s ease',
        ...style
      }}
    >
      <span>{titulo}</span>
      &nbsp;&nbsp;
      <i
        className={`fa-solid ${iconoClase}`}
        style={{
          cursor: 'pointer',
          opacity: esActivo ? 1 : 0.35,
          color: esActivo ? colorActivo : colorInactivo,
          transition: 'all 0.2s ease',
          transform: esActivo ? 'scale(1.15)' : 'scale(1)'
        }}
      />
    </th>
  );
};

export default ThOrdenable;
